module.exports = __webpack_public_path__ + "static/media/BTU-BT UNI-V2-logo.324f553c.png";